import React from 'react';
import { Chip } from "@curves/ui-base";
import { displayDateText, isValidDate } from '@util/moment';
import { COLOR_MATCH } from '@icoach/accountBook/staticData';
import { MemoControllerBox } from '@icoach/components';

const BillingRecordRowsLabel = [
    {
        cellKey: 'orderDate',
        headerLabel: '日期',
        formatCell: (cellValue, { paymentDate }) => (isValidDate(paymentDate) ? displayDateText(paymentDate) : displayDateText(cellValue)),
    },
    {
        cellKey: 'itemName',
        headerLabel: '品項',
    },
    {
        cellKey: 'paymentStatusText',
        headerLabel: '付款狀態',
        align: 'center',
        formatCell: (cellValue, { paymentStatus }) => {
            return <Chip label={cellValue} color={COLOR_MATCH[paymentStatus]} />;
        },
    },
    {
        cellKey: 'invoiceStatusText',
        headerLabel: '發票狀態',
        align: 'center',
        formatCell: (cellValue, rowData) => {
            const { invoiceStatus } = rowData;
            return <Chip label={cellValue} color={COLOR_MATCH[invoiceStatus]} />;
        },
    },
    {
        cellKey: 'invoiceNo',
        headerLabel: '發票號碼',
        align: 'center',
    },
    {
        cellKey: 'itemPrice',
        headerLabel: '金額',
        align: 'right',
    },
    {
        cellKey: 'notes',
        headerLabel: '備註',
        formatCell: (cellValue) => {
            return <MemoControllerBox data={cellValue} dialogTitle={'匯款說明'} />;
        },
    },
];

export default BillingRecordRowsLabel;
